export default __webpack_public_path__ + "static/media/dark15.9ffc9182.png";